exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center[data-v-f9204d24]{align-self:center}.prefix[data-v-f9204d24]{margin-bottom:25px}.help-btn[data-v-f9204d24]{background-color:var(--v-helpColor-base);color:var(--v-helpTextColor-base);display:flex;justify-content:center;align-items:center;width:24px;height:24px;border-radius:100%;padding-top:2px;font-weight:700}.help-btn[data-v-f9204d24]:hover{background-color:var(--v-activeHelpColor-base);color:var(--v-activeHelpTextColor-base)}.help-btn-pos[data-v-f9204d24]{margin-top:30px;transform:translateY(-50%)}", ""]);

// exports
